import { getDateFromToday } from '@common/utils/dates';

import { APITransport } from '@client/transports/api';

const normalizeRange = (range) => {
  const start = new Date(range?.startDate ? range.startDate : getDateFromToday(60));
  const end = new Date(range?.endDate ? range.endDate : getDateFromToday(0));
  const utcStart = new Date(start.getTime() + start.getTimezoneOffset() * 60000);
  const utcEnd = new Date(end.getTime() + end.getTimezoneOffset() * 60000);

  return {
    startDate: utcStart.toISOString(),
    endDate: utcEnd.toISOString()
  };
};

const generateDateRanges = ({ dateRange, googleDateRange }) => ({
  dateRange: normalizeRange(dateRange),
  googleDateRange: normalizeRange(googleDateRange)
});

export const UsersService = {
  assignUsersMDM({ mdmusers, mdmdomains, authcode }) {
    return APITransport.post({
      path: `/rest/user/execute/assignmdmusers`,
      body: {
        mdmusers,
        mdmdomains,
        authcode
      }
    });
  },
  unassignUsersMDM({ mdmusers, mdmdomains, authcode }) {
    return APITransport.post({
      path: `/rest/user/execute/unassignmdmusers`,
      body: {
        mdmusers,
        mdmdomains,
        authcode
      }
    });
  },
  getUsersMDM({ mdmusers, mdmdomains, authcode }) {
    return APITransport.post({
      path: `/rest/user/execute/getmdmusers`,
      body: {
        mdmusers,
        mdmdomains,
        authcode
      }
    });
  },
  clearCache(body) {
    return APITransport.post({
      path: '/rest/domain/execute/clearusercache',
      body
    });
  },
  exportUsers(params) {
    return APITransport.post({
      path: '/rest/domain/export/users',
      body: {
        ...params,
        ...generateDateRanges(params)
      }
    });
  },
  exportQRCodes(params) {
    return APITransport.post({
      path: '/rest/domain/export/qrcodes',
      body: {
        ...params,
        ...generateDateRanges(params)
      },
      responseType: 'arraybuffer'
    });
  },
  async getUserById(query) {
    const user = await APITransport.post({
      path: '/rest/domain/search/users',
      body: {
        query,
        systemFilter: [],
        page: 0,
        perPage: 10
      }
    });

    // APITransport resolves failures to an `{ status, message }` object, so a non-array
    // means the request failed — return undefined instead of throwing on `.find`.
    return Array.isArray(user) ? user.find(({ email }) => email === query) : undefined;
  },
  getUsers(params = {}) {
    return APITransport.post({
      path: '/rest/domain/search/users',
      includeResponseMeta: true,
      body: {
        ...params,
        page: Math.max(0, params.page - 1),
        ...generateDateRanges(params)
      }
    });
  },
  getSalesforceContact({ emails }) {
    return APITransport.post({
      path: '/rest/domain/execute/sfdccontactlink',
      body: {
        emails
      }
    });
  },
  sendReminder(body) {
    return APITransport.post({
      path: '/rest/domain/execute/remindusers',
      body
    });
  },
  updateSettings(body) {
    return APITransport.post({
      path: '/rest/user/usersettings/save',
      body
    });
  },
  updateUser(body) {
    return APITransport.post({
      path: '/rest/domain/execute/updateuser',
      body
    });
  }
};
